export const types = {
    AD_SERVICE_LIST_REQUEST: "adheredServices/AD_SERVICE_LIST_REQUEST",
    AD_SERVICE_LIST_FAILURE: "adheredServices/AD_SERVICE_LIST_FAILURE",
    AD_SERVICE_LIST_SUCCESS: "adheredServices/AD_SERVICE_LIST_SUCCESS",

    AD_SERVICE_DETAIL_REQUEST: "adheredServices/AD_SERVICE_DETAIL_REQUEST",
    AD_SERVICE_DETAIL_FAILURE: "adheredServices/AD_SERVICE_DETAIL_FAILURE",
    AD_SERVICE_DETAIL_SUCCESS: "adheredServices/AD_SERVICE_DETAIL_SUCCESS",

    AD_SERVICE_RENAME_REQUEST: "adheredServices/AD_SERVICE_RENAME_REQUEST",
    AD_SERVICE_RENAME_FAILURE: "adheredServices/AD_SERVICE_RENAME_FAILURE",
    AD_SERVICE_RENAME_SUCCESS: "adheredServices/AD_SERVICE_RENAME_SUCCESS",

    AD_SERVICE_REMOVE_REQUEST: "adheredServices/AD_SERVICE_REMOVE_REQUEST",
    AD_SERVICE_REMOVE_FAILURE: "adheredServices/AD_SERVICE_REMOVE_FAILURE",
    AD_SERVICE_REMOVE_SUCCESS: "adheredServices/AD_SERVICE_REMOVE_SUCCESS",

    CLEAN_AFIP_TICKET: "adheredServices/CLEAN_AFIP_TICKET",
    AD_SERVICE_TICKET_SUCCESS: "adheredServices/EMIT_AFIP_SUCCESS",
    SET_SERVICES_DATA: "adheredServices/SET_SERVICES_DATA",
};

export const INITIAL_STATE = {
    adheredServicesList: {},
    adheredServicesDetail: {},
    adheredServicesRename: {},
    adheredServicesRemove: {},
    fetching: false,
    adheredServicesTicket: { status: "", idTransaction: "" },
    adheredServicesData: {},
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        adheredServicesList,
        adheredServicesDetail,
        adheredServicesRename,
        adheredServicesTicket,
        adheredServicesData,
    } = action;

    switch (action.type) {
        case types.AD_SERVICE_LIST_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.AD_SERVICE_LIST_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.AD_SERVICE_LIST_SUCCESS:
            return {
                ...state,
                fetching: false,
                adheredServicesList,
            };

        case types.AD_SERVICE_DETAIL_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.AD_SERVICE_DETAIL_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.AD_SERVICE_DETAIL_SUCCESS:
            return {
                ...state,
                fetching: false,
                adheredServicesDetail,
            };

        case types.AD_SERVICE_RENAME_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.AD_SERVICE_RENAME_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.AD_SERVICE_RENAME_SUCCESS: {
            return {
                ...state,
                fetching: false,
                adheredServicesList: {
                    rapipagoServiceList: adheredServicesRename,
                },
            };
        }

        case types.AD_SERVICE_REMOVE_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.AD_SERVICE_REMOVE_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.AD_SERVICE_REMOVE_SUCCESS:
            return {
                ...state,
                fetching: false,
            };

        case types.AD_SERVICE_TICKET_SUCCESS:
            return {
                ...state,
                adheredServicesTicket,
            };
        case types.CLEAN_AFIP_TICKET:
            return {
                ...state,
                adheredServicesTicket: { status: "", idTransaction: "" },
            };
        case types.SET_SERVICES_DATA:
            return {
                ...state,
                adheredServicesData,
            };
        default:
            return state;
    }
};

export const actions = {
    adheredServicesListReducer: () => ({
        type: types.AD_SERVICE_LIST_REQUEST,
    }),
    adheredServicesDetailReducer: (serviceId) => ({
        type: types.AD_SERVICE_DETAIL_REQUEST,
        serviceId,
    }),
    adheredServicesRenameReducer: ({ serviceId, operation, path, value }) => ({
        type: types.AD_SERVICE_RENAME_REQUEST,
        serviceId,
        operation,
        path,
        value,
    }),
    adheredServicesRemoveReducer: (serviceId) => ({
        type: types.AD_SERVICE_REMOVE_REQUEST,
        serviceId,
    }),
    setAdheredServicesData: (adheredServicesData) => ({
        type: types.SET_SERVICES_DATA,
        adheredServicesData,
    }),
};

export const selectors = {
    getAfip: ({ afip }) => afip.afip,
    getList: ({ adheredServices }) => adheredServices.adheredServicesList.rapipagoServiceList,
};
